import service from '@/api/service/service';
import qs from "qs";

export default {
  file_update_start (data) {
    return service({
      method: 'POST',
      url: '/api/breakpoint/upload/start.json',
      data:qs.stringify(data)
    })
  },
  async file_update_slice (data = {}) {
    return service({
      method: 'POST',
      url: '/api/breakpoint/upload/uploadSlice.json',
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data:data
    })
  },
  async file_update_complete (data) {
    return service({
      method: 'POST',
      url: '/api/breakpoint/upload/complete.json',
      data:qs.stringify(data)
    })
  },
}
